import {PatientTherapySequence} from '@cypro/engine/schema'
import {dialog} from '@cypro/ui/components'
import {Suspense} from 'react'
import {CancelProductionDialog} from './cancel-production-dialog'

const CANCEL_PRODUCTION_DIALOG_ID = 'abort-cleanroom-dialog'

export function openCancelProductionDialog(sequence: PatientTherapySequence) {
  try {
    dialog.remove(CANCEL_PRODUCTION_DIALOG_ID)
  } catch {}

  return dialog.open(CANCEL_PRODUCTION_DIALOG_ID, {
    id: CANCEL_PRODUCTION_DIALOG_ID,
    children: (
      <Suspense fallback={null}>
        <CancelProductionDialog sequence={sequence} />
      </Suspense>
    ),
    size: 'lg',
  })
}
